import * as React from 'react'
import type { AbstractClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import { Translations } from '../../../shared/i18n/Translations'
import { Base_PureComponent } from '../Base/Base.ui.Component'
import { UI_dialogClose, UI_dialogOpen } from '../UI/UI.Dialog'
import { UI_RoundedButton } from '../UI/UI.RoundedButton'

const explanationMessage = () => Translations.t('app:Rpts.NoSpaceWarning.thereIsInsufficient')

type TProps = {
    onOk: () => void
}

export class Rpts_NoSpaceWarning extends Base_PureComponent<TProps, {}> {
    public tryRender() {
        const { onOk } = this.props

        return (
            <div className="reports_NoSpaceWarning_root">
                <img src="res/sweep.svg" className="reports_NoSpaceWarning_img" />
                <div className="reports_NoSpaceWarning_heading">
                    {Translations.t('app:Rpts.NoSpaceWarning.noStorageSpace')}
                </div>
                <div className="reports_NoSpaceWarning_expl">{explanationMessage()}</div>
                <UI_RoundedButton buttonText={Translations.t('app:UI.common.okGotIt')} style="green" onClick={onOk} />
            </div>
        )
    }
}

/**
 * displays a NoSpaceWarning dialog, and awaits user response.
 */
export function Rpts_noSpaceWarningDialog(logger: AbstractClientLogger): Promise<void> {
    logger.warn('not enough space')

    return new Promise((resolve) => {
        UI_dialogOpen(
            {
                key: 'no-space-warning-dialog',
                /* maxWidth: (fontSize * 30em) + (2 * dialogPadding) + some extra padding */
                /* minWidth: is because the default width:
                        75% looks bad on small screensand wastes width on the background */
                contentStyle: { minWidth: '280px', maxWidth: 'calc(15px * 30 + 2 * 24px + 30px)' },
                onRequestClose: () => {
                    UI_dialogClose()
                    resolve()
                },
            },
            <Rpts_NoSpaceWarning
                onOk={() => {
                    UI_dialogClose()
                    resolve()
                }}
            />
        )
    })
}
